import { INewListRequest } from "@wbmason/my-list-service";
import { ListAction } from "@wbmason/my-list-service/constants/enums";
import React, { ComponentType, Suspense } from "react";
import ServerSideService from "../../utilities/serverSideService";

export interface IManageLists {
  addToListEnabled: boolean;
  isLoggedIn: boolean;
  isCookied: boolean;
  productSet: INewListRequest | null;
  listAction: ListAction;
  pageName?: string;
}

const ClientProvider = React.lazy(
  () =>
    import(
      /* webpackMode: "eager" */
      /* webpackChunkName: "slide-outs" */
      "./manageListsClient"
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as unknown as Promise<{ default: ComponentType<any> }>
);

const ManageLists = (props: IManageLists) => {
  return (
    <>
      {ServerSideService.isServerSide ? undefined : (
        <Suspense fallback={<></>}>
          <ClientProvider {...props} />
        </Suspense>
      )}
    </>
  );
};

export default ManageLists;
